import { useFormikContext } from 'formik';
import React from 'react';

type SparkFormAutoSubmitterProps = {
  debounceDelay?: number;
};

function SparkFormAutoSubmitter({
  debounceDelay = 2000,
}: SparkFormAutoSubmitterProps) {
  const { dirty, isSubmitting, submitForm, isValid, values } =
    useFormikContext<any>();
  const prevValuesRef = React.useRef(values);
  React.useEffect(() => {
    const interval = setInterval(() => {
      if (
        JSON.stringify(prevValuesRef.current) === JSON.stringify(values) ||
        !dirty ||
        isSubmitting ||
        !isValid
      ) {
        return;
      }
      prevValuesRef.current = values;
      submitForm();
    }, debounceDelay);

    return () => clearInterval(interval);
  }, [debounceDelay, dirty, isValid, isSubmitting, submitForm, values]);

  return <></>;
}

export default SparkFormAutoSubmitter;
